import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class SequenceItemCustomOptionModel extends BaseModel {
  uuid = null;
  department_uuid = null;
  department = null;
  category_uuid = null;
  category = null;
  dropdown_option_value = null

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    department_uuid: 'required',
    category_uuid: 'required',
    dropdown_option_value: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
  }

}
